import React, { useEffect, useState } from "react";
import { formadate } from "../../_App/Helpers/helpers";
import { ProgramFideliteType } from "../../_App/Types/Entites/RemiseType";
import { NiveauFideliteType } from "../../_App/Types/Entites/ClientType";
import {
  deleteFidelite,
  updateFideliteApi,
} from "../../_App/Redux/Slices/client/clientSlice";
import { useAppDispatch } from "../../_App/Redux/hooks";

export default function FideliteTable({
  ProgramsFidelites,
  updateFunction,
  activeFunction,
  t,
}: any) {
  const [List, setList] = useState<ProgramFideliteType[]>([]);
  useEffect(() => {
    setList(ProgramsFidelites);
  }, [ProgramsFidelites]);
  const [keyword, setkeyword] = useState("");

  const handelsearch = () => {
    const lowercaseKeyword = keyword.toLowerCase();
    const listFiltrer = ProgramsFidelites.filter(
      (item: any) =>
        item.nom.toLowerCase().includes(lowercaseKeyword) ||
        item.prenom.toLowerCase().includes(lowercaseKeyword),
    );

    setList(listFiltrer);
    if (keyword === "") {
      setList(ProgramsFidelites);
    }
  };
  const dispatch = useAppDispatch();
  return (
    <div>
      <div className=" row ">
        <div className="col-4">
          <input
            type="text"
            className="form-control product-search br-30 "
            id="input-search"
            placeholder={t("chercher par mot cle")}
            onChange={(e) => setkeyword(e.target.value)}
          />
        </div>
        <div className="col-3">
          <button className="btn btn-primary-app" onClick={handelsearch}>
            {t("chercher")}
          </button>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">{t("Libelle")}</th>
              <th scope="col">{t("Points")}</th>
              <th scope="col">{t("Equivalence (dt)")}</th>

              <th scope="col">{t("Date début")}</th>
              <th scope="col">{t("Date fin")}</th>
              <th scope="col">{t("Catégorie client")}</th>

              <th scope="col">{t("Status")}</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {List.map((item, index) => (
              <tr key={index}>
                <td>{item.libelle}</td>
                <td>{item.points}</td>
                <td>{item.equivalentMoney.toFixed(3)}</td>

                <td>{item.date_debut?.toString().split("T")[0]}</td>
                <td>{item.date_fin?.toString().split("T")[0]}</td>
                <td>
                  {(item?.conditions_clients?.length > 0 &&
                    item?.conditions_clients[0]?.niveau_fidelite_details
                      ?.map((niveau: NiveauFideliteType) => niveau.libelle)
                      .join(", ")) ||
                    "Tous"}
                </td>

                <td> {item.actif ? "Actif" : "Inactif"} </td>

                {item.actif ? (
                  <>
                    <td>
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "1.5em",
                          marginRight: "10px",
                          color: "green",
                        }}
                        onClick={() =>
                          dispatch(
                            updateFideliteApi({
                              fidelite: { _id: item._id, actif: false },
                            }),
                          )
                        }
                      >
                        {" "}
                        <i className="fas fa-power-off"></i>
                      </span>
                    </td>
                    <td>
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "1.5em",
                          marginRight: "10px",
                        }}
                        onClick={() => updateFunction(item)}
                      >
                        <i
                          className="fas fa-edit"
                          style={{ color: "#06958d" }}
                        ></i>
                      </span>
                    </td>
                  </>
                ) : (
                  <>
                    <td>
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "1.5em",
                          marginRight: "10px",
                          color: "red",
                        }}
                        onClick={() =>
                          dispatch(
                            updateFideliteApi({
                              fidelite: { _id: item._id, actif: true },
                            }),
                          )
                        }
                      >
                        {" "}
                        <i className="fas fa-power-off"></i>
                      </span>
                    </td>
                  </>
                )}
                <td>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "1.5em",
                      marginRight: "10px",
                      color: "red",
                    }}
                    onClick={() => dispatch(deleteFidelite(item._id))}
                  >
                    {" "}
                    <i className="fas fa-times"></i>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
